import * as NoticeActions from '../actions';

const initState = {
  data: [],
  loading: false,
  message: null,
  recentPatientActivity: {
    data: [],
    loading: true,
    message: null,
  },
};

const noticeReducer = (state = initState, actions) => {
  const { type, payload } = actions;

  switch (type) {
    case NoticeActions.NOTICE_GET_LIST:
      return { ...state, loading: true, message: null };
    case NoticeActions.NOTICE_GET_LIST_SUCCESS:
      return { ...state, loading: false, data: payload };
    case NoticeActions.NOTICE_GET_LIST_FAIL:
      return { ...state, loading: false, message: payload.message };
    case NoticeActions.NOTICE_RECENT_PATIENT_ACTIVITY_GET_LIST:
      return {
        ...state,
        recentPatientActivity: { ...state.recentPatientActivity, loading: true, message: null },
      };
    case NoticeActions.NOTICE_RECENT_PATIENT_ACTIVITY_GET_LIST_SUCCESS:
      return {
        ...state,
        recentPatientActivity: { ...state.recentPatientActivity, loading: false, data: payload },
      };
    case NoticeActions.NOTICE_RECENT_PATIENT_ACTIVITY_GET_LIST_FAIL:
      return {
        ...state,
        recentPatientActivity: {
          ...state.recentPatientActivity,
          loading: false,
          data: [],
          message: payload.message,
        },
      };
    default:
      return state;
  }
};

export default noticeReducer;
